/**
 * WCAG 2.4.1 Bypass Blocks — allow keyboard users to jump past the nav to the
 * main content. The link is visually hidden until focused.
 */
export function SkipLink() {
  return (
    <a href="#main-content" className="skip-link">
      Skip to main content
    </a>
  );
}
